// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/categories-cars/list',
    name: 'categories-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Categories.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_categories_cars',
    },
  },
]

export default formTable
